import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { makeStyles } from "@material-ui/core/styles";
import InputLabel from "@material-ui/core/InputLabel";
import FormControl from "@material-ui/core/FormControl";
import MailOutline from "@material-ui/icons/MailOutline";
import Swal from "sweetalert2";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardIcon from "components/Card/CardIcon.js";
import CardBody from "components/Card/CardBody.js";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import axios from "../../utils/axiosInstance"; 
import styles from "assets/jss/material-dashboard-pro-react/views/validationFormsStyle.js";
import { useNavigate } from "react-router-dom";
import stylesData from "assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.js";
import { toast } from "react-toastify";
import { Box, CircularProgress } from "@material-ui/core";
const useStyleData = makeStyles(stylesData);
const useStyles = makeStyles(styles);

export default function EditAdmin() {
  const searchParams = new URLSearchParams(window.location.search);
  const userId = searchParams.get("userId");
  const classes = useStyles();
  const navigate = useNavigate();
  const [roles, setRoles] = useState([]);
  const [loading, setLoading] = useState(false);
  const [alert, setAlert] = useState(null);
  const [initialFormValues, setInitialFormValues] = useState(null);

  useEffect(() => {
    getRoles();
  }, []);

  const getRoles = async () => {
    const token = localStorage.getItem("token");
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API_URL_PREFIX}/api/v1/admin/getRoles`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setRoles(res.data.role);
    } catch (err) {
      console.error(err);
      if (
        err.response?.data?.message ===
        "For security reasons, we locked your account.Please login to continue"
      ) {
        localStorage.removeItem("token");
        window.location.assign("/auth/login-page");
      } else {
        Swal.fire({
          text: err.response?.data?.message || "Something went wrong!",
        });
      }
    }
  };
  const handleSubmitForm = async (values) => {
    const token = localStorage.getItem("token");

    try {
      const response = await axios.patch(
        `${process.env.REACT_APP_API_URL_PREFIX}/api/v1/admin/updateAdminById?id=${userId}`,
        {
          firstName: values.firstName,
          lastName:values.lastName,
          email: values.email,
          roleId: values.roleId,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.status === 200) {
        toast.success("Admin updated successfully");
        setInitialFormValues({ ...values });
        navigate("/admin/userManagement/viewAdmin", { state: { shouldRefetch: true } });

      }
    } catch (err) {
      toast.error("Error updating admin");
      console.error(err);
    }
  };

  const formik = useFormik({
    initialValues: {
      firstName: "", lastName: "",
      email: "",
      roleId: "",
    },

    validationSchema: Yup.object({
      firstName: Yup.string().required("Firstname is required"),
      lastName: Yup.string().required("Lastname is required"),
      email: Yup.string().email("Invalid email").required("Email is required"),
      roleId: Yup.string().required("Role is required"),
    }),
    onSubmit: async (values) => {
      handleSubmitForm(values);
    },
  });
  const isFormChanged = initialFormValues &&
    JSON.stringify(formik.values) !== JSON.stringify(initialFormValues);
  useEffect(() => {
    const token = localStorage.getItem("token");
    const getAdminUserById = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL_PREFIX}/api/v1/admin/getadminusersid?id=${userId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );

        if (response?.data?.data) {
          const { firstName,lastName, email, role } = response.data.data;

          const populatedValues = {
            firstName:firstName||"",
            lastName:lastName||"",
            email: email || "",
            roleId: role || "",
          };

          formik.setValues(populatedValues);
          setInitialFormValues(populatedValues);
        }
      } catch (error) {
        console.error("Error fetching admin user:", error);
      }
    };

    getAdminUserById();
  }, [userId]);
  return (
    <GridContainer>
      <GridItem xs={12}>
        <Card>
          <CardHeader color="rose" icon>
            <CardIcon color="rose">
              <MailOutline />
            </CardIcon>
            <h4 className={classes.cardIconTitle}>Edit Manager</h4>
          </CardHeader>
          <CardBody>
            <form onSubmit={formik.handleSubmit}>
              <Box sx={{
                maxWidth: "70%", margin: "0 auto", "@media screen and (max-width:992px)": {
                  maxWidth: "100%"
                }
              }}>
                <GridContainer>
                  <GridItem xs={12} sm={12} md={6}>
                    <CustomInput
                      labelText="Full Name"
                      id="firstName"
                      formControlProps={{ fullWidth: true }}
                      inputProps={{
                        value: formik.values.firstName,
                      }}
                      handleChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      error={formik.touched.firstName && Boolean(formik.errors.firstName)}
                      helperText={formik.touched.firstName && formik.errors.firstName}
                    />
                  </GridItem>
                  <GridItem xs={12} sm={12} md={6}>
                    <CustomInput
                      labelText="Last Name"
                      id="lastName"
                      formControlProps={{ fullWidth: true }}
                      inputProps={{
                        value: formik.values.lastName,
                      }}
                      handleChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      error={formik.touched.lastName && Boolean(formik.errors.lastName)}
                      helperText={formik.touched.lastName && formik.errors.lastName}
                    />
                  </GridItem>

                  <GridItem xs={12} sm={12} md={6}>
                    <CustomInput
                      labelText="Email"
                      id="email"
                      formControlProps={{ fullWidth: true }}
                      inputProps={{
                        value: formik.values.email,
                        onChange: formik.handleChange,
                        onBlur: formik.handleBlur,
                      }}
                      error={formik.touched.email && Boolean(formik.errors.email)}
                      helperText={formik.touched.email && formik.errors.email}
                    />
                  </GridItem>
                  <GridItem xs={12} sm={12} md={3}>
                    <FormControl
                      fullWidth
                      className={classes.selectFormControl}
                      style={{ marginTop: "10px" }}
                    >
                      <InputLabel
                        htmlFor="roleId"
                        className={classes.selectLabel}
                      >
                        Select Role Name
                      </InputLabel>
                      <Select
                        label="Select Role Name"
                        id="roleId"
                        name="roleId"
                        value={formik.values.roleId}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={
                          formik.touched.roleId && Boolean(formik.errors.roleId)
                        }
                        inputProps={{
                          style: {
                            height: "30px",
                            padding: "5px 10px",
                            fontSize: "14px",
                          },
                        }}
                      >
                        {roles.map((role) => (
                          <MenuItem key={role._id} value={role._id}>
                            {role.name}
                          </MenuItem>
                        ))}
                      </Select>
                      {formik.touched.roleId && formik.errors.roleId && (
                        <div
                          style={{
                            color: "red",
                            fontSize: "12px",
                            marginTop: "10px",
                          }}
                        >
                          {formik.errors.roleId}
                        </div>
                      )}
                    </FormControl>
                  </GridItem>
                </GridContainer>
                {!loading ? (
                  <Button
                    color="rose"
                    type="submit"
                    className={classes.registerButton}
                    disabled={!isFormChanged}
                    onClick={formik.handleSubmit}
                  >
                    Save Changes
                  </Button>
                ) : (
                  <div className={classes.registerButton}>
                    <CircularProgress size={24} color="inherit" />
                  </div>
                )}
              </Box>
              <br />
            </form>
          </CardBody>
        </Card>
      </GridItem>
      {alert}
    </GridContainer>
  );
}
